import { render, staticRenderFns } from "./ParamGroups.vue?vue&type=template&id=91f39754&"
import script from "./ParamGroups.vue?vue&type=script&lang=js&"
export * from "./ParamGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports